import * as React from 'react'

// TODO: Deprecate this class, it's full of hacks
export interface CalendarLeavesContext {
  lastLeaveUpdatedInMilliseconds: number
  momentLocalizer: any
  onChangeLeave: () => void
}

export const store = React.createContext<CalendarLeavesContext | null>(null)

const Provider = store.Provider
interface Props {
  momentLocalizer: any
}

export const CalendarLeavesProvider = ({
  children,
  momentLocalizer,
}: React.PropsWithChildren<Props>) => {
  const [lastLeaveUpdatedInMilliseconds, setLastUpdatedLeave] = React.useState(0)

  const onChangeLeave = () => {
    setLastUpdatedLeave(new Date().getTime())
  }

  return (
    <Provider
      value={{
        momentLocalizer,
        lastLeaveUpdatedInMilliseconds,
        onChangeLeave,
      }}
    >
      {children}
    </Provider>
  )
}
